import React from 'react';
import { connect } from 'react-redux';
import Form from '../../../components/form/form';
import Message from '../../../components/message/index';
import Breadcrumb from '../../../components/breadcrumb/index';
import moment from 'moment';
import { invoiceReport, invoiceDetailReport, exportOmsgReport, virtualNumberList } from '../../../actions/actions';
import { scrollToTop } from '../../../actions/utils';
import Select from '../../../components/form/select';
import ReportDetail from './detail';

class InvoiceReport extends React.Component {
    constructor(props)
    {
        super(props)
        this.reportRef = React.createRef();


        this.state = {
            itemDetailsToShow: {},
            list: [],
            pageSize: 0,
            pageNumber: 0,
            virtualNumberList: [],
            totalItemCount: 0,
            downloadOptions: {
                value: 'PDF',
                name: 'downloadOptions',
                type: 'select',
                label: '',
                placeholder: 'Dosya Tipi',
                options: [{name: 'PDF', value: 'pdf'},{name: 'Excel', value: 'xlsx'}],
                error: 'Lütfen dosya tipi seçiniz.',
                valid: true,
                touched: false,
                validationRules: {
                    isRequired: true
                }
            },
            formModel: {
                virtualNumber: {
                    value: '',
                    name: 'virtualNumber',
                    type: 'select',
                    label: 'Sanal Numara',
                    placeholder: 'Sanal Numara',
                    error: 'Lütfen Sanal Numara girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
                invoicePeriodMonth: {
                    value: '',
                    name: 'invoicePeriodMonth',
                    type: 'select',
                    label: 'Fatura Dönemi - Ay',
                    placeholder: 'Fatura Dönemi',
                    options: this.getInvoicePeriodMonth(),
                    error: 'Lütfen fatura dönemi için ay seçiniz.',
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
                invoicePeriodYear: {
                    value: '',
                    name: 'invoicePeriodYear',
                    type: 'select',
                    label: 'Fatura Dönemi - Yıl',
                    placeholder: 'Fatura Dönemi',
                    options: this.getInvoicePeriodYear(),
                    error: 'Lütfen fatura dönemi yıl seçiniz.',
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                }
            }
            
        };

        this.getVirtualNumberList();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data)
    {
        this.getReport(data);
    }

    getReport(data){
        var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === data.virtualNumber).product;
        foundedObj.tariff = foundedObj.tariffPlan;
        this.props.dispatch(invoiceReport({...data, ...foundedObj}, (response) => {
            this.setState({
                itemDetailsToShow: [],
                list: response.reportItems,
                pageNumber: response.pageNumber,
            });
        }, (data) => {
            scrollToTop();
        }));
    }

    downloadReport() {
        if(this.state.downloadOptions.value != '') {
            var foundedObj = this.state.virtualNumberList.find(vm => vm.virtualNumber === this.state.formModel.virtualNumber.value);
            let requestData = {
                type: 'invoice',
                docType: this.state.downloadOptions.value,
                reportRequest: {
                    virtualNumber:this.state.formModel.virtualNumber.value,
                    invoicePeriodMonth:this.state.formModel.invoicePeriodMonth.value,
                    invoicePeriodYear:this.state.formModel.invoicePeriodYear.value,
                    pageNumber: this.state.pageNumber,
                    ...foundedObj
                }
            }
            this.props.dispatch(exportOmsgReport(requestData, () => {
            }, () => {
    
            }));
        }
    }

    getVirtualNumberList(){
        this.props.dispatch(virtualNumberList((response) => {
        }, (data) => {
            this.setState({
                virtualNumberList: data,
                formModel: {
                    ...this.state.formModel,
                    virtualNumber: {
                        ...this.state.formModel.virtualNumber,
                        options: data.map(x => ({value:x.product.virtualNumber, name:x.product.virtualNumber}))
                    }
                }
            })
        }));
    }

    getInvoicePeriodMonth(){
        return [
            {name: 'Ocak', value: '1'},
            {name: 'Şubat', value: '2'},
            {name: 'Mart', value: '3'},
            {name: 'Nisan', value: '4'},
            {name: 'Mayıs', value: '5'},
            {name: 'Haziran', value: '6'},
            {name: 'Temmuz', value: '7'},
            {name: 'Ağustos', value: '8'},
            {name: 'Eylül', value: '9'},
            {name: 'Ekim', value: '10'},
            {name: 'Kasım', value: '11'},
            {name: 'Aralık', value: '12'},
        ];
    }

    getInvoicePeriodYear(){
        return [
            {name: '2019', value: '2019'},
            {name: '2020', value: '2020'},
            {name: '2021', value: '2021'},
            {name: '2022', value: '2022'},
            {name: '2023', value: '2023'},
            {name: '2024', value: '2024'},
        ];
    }

    async changePage(nextPageNumber){
        if(nextPageNumber === -1 && this.state.pageNumber === 0) {

        } else {
            this.getReport({virtualNumber:this.state.formModel.virtualNumber.value, pageNumber: nextPageNumber});
        }
    }
    
    handleItemClick(index){
        this.props.dispatch(invoiceDetailReport({
            virtualNumber:this.state.formModel.virtualNumber.value,
            invoicePeriodMonth:this.state.formModel.invoicePeriodMonth.value,
            invoicePeriodYear:this.state.formModel.invoicePeriodYear.value,
        }, (response) => {
            var itemDetailsToShow = {index, items: response.reportItems};
            this.setState({
                itemDetailsToShow: itemDetailsToShow
            }, () => {
            });
        }, (data) => {
            scrollToTop();
        }));
        
    }

    sendReportChangePage(pageNumber, pageSize) {
        this.getReport({virtualNumber: this.state.formModel.virtualNumber.value, pageNumber, pageSize});
    }

    handleSelectDownloadOption(data){
        this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
    }

    handleSelectInvoicePeriod(data){
        this.setState({invoicePeriod: {...this.state.invoicePeriod, value: data.target.value}})
    }

    render() {
        const breadcrumbItems = [{
            name: "Fatura Dönemi Raporu"
        }];

        return (
        [
            <Breadcrumb items={breadcrumbItems} />,
            <section className="panel">
                <Message />
                <div className="container">
                    <div className="reports">
                        <div className="title-default">
                            <span>Fatura Dönemi Raporu</span>
                        </div>
                        <div className="report-form">
                            <Form model={this.state.formModel} handleSubmit={this.handleSubmit} smallTitle={""} buttonText={"Rapor Oluştur"} buttonId={"report-list-filter"} />
                        </div> 
                        {this.state.list.length > 0 && 
                        <div>
                               <div style={{display: 'table', textAlign:'center', width: '100%', margin:'10px 0 10px 0'}}>
                            <div style={{display:'table-cell', width:'50vh', verticalAlign:'middle', paddingRight:'5px'}}>
                            <Select data={this.state.downloadOptions} handleChange={this.handleSelectDownloadOption.bind(this)} />

                            </div>
                            <div style={{display:'table-cell', width:'50vh', paddingLeft:'5px'}}>
                            <a id="report-send-download" className="btn primary" href="javascript:void(0)" title="Tümünü indir" onClick={this.downloadReport.bind(this)}>
                                                    <span>Tümünü indir</span>
                                                </a>
                            </div>
                        </div>
                                <div className="report-items">
                                    <div ref={this.reportRef} className="head custom-report-head">
                                        <div className="item custom-invoice-report-head">
                                            <div>Sanal Numara</div>
                                            <div>Tarife Adı</div>
                                            <div>Birim Fiyat</div>
                                            <div>Sözleşmedeki Mesaj Adedi</div>
                                            {/*<div>Toplam Gönderilen Mesaj Adedi</div>*/}
                                            {/*<div>Kalan Mesaj Adedi</div>*/}
                                            <div>Fatura Dönemi</div>
                                            <div>Fatura Tutarı</div>
                                            <div>Başarılı Gönderilen Mesaj Adedi</div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        {this.state.list.map((item, i) =>
                                            <div className="item custom-invoice-report-item" onClick={() => this.handleItemClick(i)}>
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarife Adı</span>
                                                    <span>{item.tariff}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Birim Fiyat</span>
                                                    <span>{item.unitPrice}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Sözleşmedeki Mesaj Adedi</span>
                                                    <span>{item.contractCount}</span>
                                                </div>
                                              {/*  <div>
                                                    <span className="label">Başarılı Gönderilen Mesaj Adedi</span>
                                                    <span>{item.smsTotal}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Kalan Mesaj adedi</span>
                                                    <span>{item.remainingContractCount}</span>
                                                </div>*/}
                                                <div>
                                                    <span className="label">Fatura Dönemi</span>
                                                    <span>{item.selectedInvoiceDate}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Fatura Tutarı</span>
                                                    <span>{item.amountWithTax}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarılı İletilen Abone Sayısı</span>
                                                    <span>{item.success}</span>
                                                </div>
                                                {this.state.itemDetailsToShow.index === i &&
                                                    <ReportDetail items={this.state.itemDetailsToShow.items} />
                                                }
                                            </div>
                                            )}
                                    </div>
                                </div>
                          
                        </div>
                          }
                        {this.state.list.length > 0 &&
                            <div className="paging">
                                {this.state.pageNumber !== 0 && <a href="javascript:void(0)" className={"first-item"} onClick={() => this.changePage(-1)}>&lt;&lt;</a>}
                                <a href="javascript:void(0)" className={"last-item"}  onClick={() => this.changePage(+1)}>&gt;&gt;</a>
                            </div>
                          }
                    </div>
                </div>
            </section>
        ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}


export default connect(mapStateToProps)(InvoiceReport)